import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 28, className }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.15 }}
        transition={{ duration: 0.7, delay, ease: EASE }}
    >
        {children}
    </motion.div>
);

export const SectionHead = ({ index, eyebrow, title, note }) => (
    <Reveal className="mb-12 lg:mb-16">
        <div className="flex items-center gap-4 font-mono text-[11px] tracking-[0.35em]">
            <span className="text-blast-pink">{index}</span>
            <span className="h-px w-12 bg-blast-pink/50" />
            <span className="text-white/50">{eyebrow}</span>
        </div>
        <h2 className="mt-5 font-display text-3xl font-bold uppercase leading-[1.05] sm:text-4xl lg:text-5xl">
            {title}
        </h2>
        {note && <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/50">{note}</p>}
    </Reveal>
);
